import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { loginRequest } from '../auth/msalConfig.js';

/**
 * Kleine inlog-status in de topnavigatie.
 * - Niet ingelogd → knop "Inloggen met Microsoft" (redirect-flow).
 * - Wel ingelogd → naam/e-mail van het account + "Uitloggen".
 * Stijl gespiegeld aan de bestaande nav (donkere header, blauw/wit-palet).
 * NOG GEEN medewerker-koppeling of token-controle — dat is stap 3b/3c.
 */
export default function LoginKnop() {
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // MSAL laat maar één interactie tegelijk toe; een tweede klik geeft
  // BrowserAuthError: interaction_in_progress. Deze status is globaal, dus de guard
  // werkt ook met de twee LoginKnop-instanties die tegelijk in de boom staan.
  const bezig = inProgress !== InteractionStatus.None;

  if (!isAuthenticated) {
    return (
      <button
        onClick={() => instance.loginRedirect(loginRequest)}
        disabled={bezig}
        className="px-3 py-1.5 rounded-md text-sm font-medium text-white border border-white/30 hover:bg-white/10 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {bezig ? 'Bezig met inloggen...' : 'Inloggen met Microsoft'}
      </button>
    );
  }

  const account = instance.getActiveAccount() ?? accounts[0];
  const volledigeNaam = account?.name ?? account?.username ?? 'Ingelogd';
  const weergavenaam = volledigeNaam.split('|')[0].trim();

  return (
    <div className="flex items-center gap-3">
      <span className="text-sm text-brand-100" title={account?.username}>{weergavenaam}</span>
      <button
        onClick={() => instance.logoutRedirect({ account, logoutHint: account?.idTokenClaims?.login_hint })}
        disabled={bezig}
        className="px-3 py-1.5 rounded-md text-sm font-medium text-brand-100 hover:text-white hover:bg-white/10 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Uitloggen
      </button>
    </div>
  );
}
